<template>
    <ul class="health-check-antenna">
        <li>
            <img
                :src="antennaQualityIcon"
                :alt="antennaQualityLabel"
                data-test-id="antenna-quality-icon"
            />
            <span data-test-id="antenna-quality-label">{{ antennaQualityLabel }}</span>
        </li>
    </ul>
</template>

<script>
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import { ANTENNA_QUALITIES } from '../radio-status-definitions'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],

    computed: {
        antennaQualityIcon() {
            let filename = `antenna-${ANTENNA_QUALITIES.UNKNOWN.toLowerCase()}.svg`
            if (this.row.antenna_quality in ANTENNA_QUALITIES) {
                filename = `antenna-${this.row.antenna_quality.toLowerCase()}.svg`
            }
            return `/images/relays/${filename}`
        },
        antennaQualityLabel() {
            let label = ANTENNA_QUALITIES.UNKNOWN
            if (this.row.antenna_quality in ANTENNA_QUALITIES) {
                label = ANTENNA_QUALITIES[this.row.antenna_quality]
            }
            return label
        },
    },
}
</script>

<style scoped lang="scss">
.health-check-antenna {
    li {
        display: flex;
        align-items: center;

        &:not(:last-child) {
            margin-bottom: 10px;
        }

        span {
            margin-left: 10px;
        }
    }
}
</style>
